import svgToTinyDataUri from '../svg-to-mini-data-uri';

const footerLocationIconSvg = `<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path
    d="M8 1c-2.5 0-4.5 2-4.5 4.5C3.5 9 8 15 8 15s4.5-6 4.5-9.5C12.5 3 10.5 1 8 1z"
    stroke="#2B2A35"
    stroke-width="1.5"
    stroke-linecap="round"
    stroke-linejoin="round"
  />
  <circle cx="8" cy="5.5" r="1.75" stroke="#2B2A35" stroke-width="1.5" />
</svg>`;

export const footerLocationIcon = svgToTinyDataUri(footerLocationIconSvg);
